import "./FlexiImg.scss";

const FlexiImg = () => {
  return (
    <div className="FlexiImg">
      <div className="row">
        <div className="col col-1"></div>
        <div className="col col-2"></div>
        <div className="col col-3"></div>
        <div className="col col-4"></div>
      </div>
    </div>
  );
};

export default FlexiImg;
